import { noop } from 'lodash';
import { createContext, createRef, MutableRefObject } from 'react';
import { KeyboardManager } from './hooks/useKeyboardManager';
import { DocumentsThumbnails } from './types';

export interface PDFScrollableContextValue {
  disableFormFields?: boolean;
  showPageBorders?: boolean;
  /**
   * A layer inside the scroll area but outside the zoom transform. Callouts
   * render here so they keep their size when zoomed, and so Popper, which
   * mismeasures inside a scaled element, positions them correctly. It covers
   * the pages, so it resizes whenever a page streams in or is redrawn.
   */
  calloutLayer?: HTMLElement | null;
  visiblePages?: number[];
  visibleDocumentIndex?: number;
  visiblePageNumber?: number;
  observer?: IntersectionObserver;
  scrollableRef?: HTMLDivElement | null;
  keyboardManager?: KeyboardManager;
  zoom: number;
  thumbnailPages?: number[];
  documentsThumbnailsRef: MutableRefObject<
    DocumentsThumbnails | null | undefined
  >;
  setDocumentsThumbnails?: (documentsThumbnails: DocumentsThumbnails) => void;
}

export const PDFScrollableContext = createContext<PDFScrollableContextValue>({
  zoom: 1,
  setDocumentsThumbnails: noop,
  documentsThumbnailsRef: createRef<DocumentsThumbnails>(),
});
